// extracted by mini-css-extract-plugin
export default {"text1":"Home_text1__1eORK","resumeHome":"Home_resumeHome__19p6g"};